import * as React from "react";
const SvgHorizontalSplit = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 19h18v-6H3v6zm0-8h18V9H3v2zm0-6v2h18V5H3z",
  fill: "currentColor"
}));
export default SvgHorizontalSplit;